import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // Data is fresh for 5 minutes
      gcTime: 1000 * 60 * 30,   // Keep unused data for 30 minutes
      retry: 1,
      refetchOnWindowFocus: false, // Prevents aggressive refetching during dev
    },
  },
});